/**
 * @generated SignedSource<<8a0865417dc5e8ace3806636c1df552c>>
 * @relayHash dc55b79a751a00f28ff80f2d5980c1e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 198ee51c787ac9d5c60bb5ff3785ed30e0c6ebb1c53b83a5230b4724aa02411c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type metricGridReportingQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type metricGridReportingQuery$data = {
  readonly helpCenter: {
    readonly helpCenterReportingById: {
      readonly __typename: "HelpCenterReporting";
      readonly performanceIndicatorsWithMetaData: {
        readonly performanceIndicators: ReadonlyArray<{
          readonly currentValue: string;
          readonly name: string;
          readonly previousValue: string | null | undefined;
          readonly timeWindow: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type metricGridReportingQuery = {
  response: metricGridReportingQuery$data;
  variables: metricGridReportingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterQueryApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
          }
        ],
        "kind": "LinkedField",
        "name": "helpCenterReportingById",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "HelpCenterReportingPerformanceIndicatorsWithMetaData",
                "kind": "LinkedField",
                "name": "performanceIndicatorsWithMetaData",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "HelpCenterReportingPerformanceIndicator",
                    "kind": "LinkedField",
                    "name": "performanceIndicators",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "currentValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "previousValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "timeWindow"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "HelpCenterReporting"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "metricGridReportingQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "metricGridReportingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "198ee51c787ac9d5c60bb5ff3785ed30e0c6ebb1c53b83a5230b4724aa02411c",
    "metadata": {},
    "name": "metricGridReportingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cfc71e0ffb7c4a3b5fa9a415550fca40";

export default node;
